import type {AppMenuContextProviderProps} from "./types";
import {AppMenuContext} from "./context";

export const AppMenuProvider = ({children, value}: AppMenuContextProviderProps) => {
  return (
    <AppMenuContext.Provider value={value}>
      {children}
    </AppMenuContext.Provider>
  );
};